<template>
  <div class="policy_article_detail">
    <div class="box-contentposition">
      <div class="back" @click="backHome">
        <i class="el-icon-s-platform"></i>
        首页
      </div>
      当前位置： 目录 > <span @click="back" class="back-word">{{backTitle}}</span> > 信息详情
    </div>
    <div class="article_body">
      <div class="title">{{dataForm.titile}}</div>
      <div class="sub_title" v-show="dataForm.subTitle">{{dataForm.subTitle}}</div>
      <div class="info">
        <div>浏览量：{{(dataForm.viewCount||dataForm.viewCount==0)? dataForm.viewCount:'--'}}</div>
        <div>来源：{{dataForm.articleSource}}</div>
        <!-- <div>发布时间：{{intToDate(dataForm.pulishTime)}}</div> -->
      </div>
      <div class="content" v-show="dataForm.content" v-html="dataForm.content" style="width: 800px; height: 100%; "></div>
      <div class="content" v-show="!dataForm.content && dataForm.converImgUrl">
        <el-image
          style="width: 100%; height: 100%;"
          :src="dataForm.converImgUrl"
          fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import API from "@/api/bigScreen/api_big_screen";
  export default {
    data(){
      return {
        articleId: '',
        dataContent: '',
        backTitle: '',
        dataForm:{},
      }
    },
    created(){
      this.articleId = this.$route.query.id;
      this.backTitle = this.$route.query.title
      this.backId = this.$route.query.tabId
      this.getDetail()
    },
    methods:{
      backHome() {
        this.$router.push({ path: "/homepage/home" })
      },

      back() {
        this.$router.push({
          path: "/policy/policyList",
          query: {
            category: this.backId
          }
        })
      },
      async getDetail(){
        let params = {
          number: this.articleId,
        };
        let { code, data } = await API.policyDetail(params);
        if (code == 0) {
          this.dataForm = data.article||{}
          this.dataForm.content = this.dataForm.content||''

        }
      },
      intToDate(number) {
        let str = "--";
        if (number) {
          let dateStr = number + "";
          let year = dateStr.substring(0, 4);
          let month = dateStr.substring(4, 6);
          let day = dateStr.substring(6);
          str = year + "年" + month + "月" + day + "日";
        }
        return str;
      },
    }

  }
</script>

<style lang="less" scoped>
  .back-word {
    display: inline-block;
    cursor: pointer;
    margin: 0 4px;

    &:hover {
      color: #02A7F0;
    }
  }

  .box-contentposition{
    padding-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .back {
    width: 55px;
    padding: 4px 8px;
    border: 1px solid #00D7FE;
    border-radius: 20px;
    cursor: pointer;
    margin-right: 16px;
  }
.policy_article_detail {
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    .article_body {
      // display: flex;
      box-sizing: border-box;
      width: 100%;
      min-height: calc(100vh - 426px);
      background: #fff;
      padding: 40px 200px;
      color: #535353;
      >div{
        width: 100%;
      }
      .title{
        // height: 40px;
        line-height: 30px;
        padding-bottom: 16px;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
      .sub_title{
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        text-align: center;
      }
      .info{
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        >div{
          padding: 0 10px;
        }
      }
    }
}

/deep/ .content img {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/studio/policy/components/article.vue